import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';


export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();
  listOfRoutes=[
    'languages',
    'cities',
    'categories',
    'sub-categories',
    'skills',
    'company-types',
    'companies',
    'departments',
    'institutes',
    'majors',
    'prof-certs',
    'all',
    'interviews-management'
  ]
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    console.log(route.routeConfig)
    return this.listOfRoutes.includes(route.routeConfig.path);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.storedRoutes.set(route.routeConfig.path, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return !!route.routeConfig && !!this.storedRoutes.get(route.routeConfig.path);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return this.storedRoutes.get(route.routeConfig.path);
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}